<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t('huntingWordsGenerator.card.actions') }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button
            @click.prevent="toggleModal()"
            :disabled="!canExport"
            class="btn-dark btn-block"
          >
            {{ $t('shared.actions.export') }}
          </d-button>

          <p
            v-if="!canExport"
            class="text-muted mb-0 small"
            style="color: #6c757d !important"
          >
            {{ $t('huntingWordsGenerator.sidebar.exportHint') }}
          </p>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer
      class="border-top d-flex flex-column flex-xl-row justify-content-around"
    >
      <d-button
        @click="save"
        type="button"
        class="btn-primary mb-3 mb-xl-0 col-xl-5"
      >
        {{ $t('shared.actions.save') }}
      </d-button>
      <d-button class="btn-secondary text-white col-xl-5" @click="goBack">
        {{ $t('shared.actions.back') }}
      </d-button>
    </d-card-footer>
    <export-file-modal
      gameType="wordsearch"
      :items="exportItems"
      :fileName="
        model.name || $t('huntingWordsGenerator.sidebar.defaultFileName')
      "
    />
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import ExportFileModal from '_common/shared/ExportFileModal.vue';

import { MODEL } from './HuntingWordsModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  components: { ExportFileModal },
  computed: {
    canExport() {
      const isGrouped = this.model?.settings?.enableGroupedGeneration;
      const { hasChanges } = this.$store.state.huntingWordsGenerator;
      const isPageCreation = !this.$route.params.puzzleId;

      if (isPageCreation) {
        return false;
      }

      if (hasChanges) return false;

      if (isGrouped) {
        return (
          Array.isArray(this.model?.children) && this.model.children.length > 0
        );
      }

      return Array.isArray(this.model?.table) && this.model.table.length > 0;
    },
    exportItems() {
      if (this.model.children && this.model.children.length > 0) {
        return this.model.children.map(child => ({
          table: child.table,
          rows: this.model.rows,
          columns: this.model.columns,
          highlightedWords: child.settings?.placedWords || [],
        }));
      }

      return [
        {
          name: this.model.name,
          table: this.model.table || [],
          rows: this.model.rows,
          columns: this.model.columns,
          highlightedWords: this.model.settings?.placedWords || [],
        },
      ];
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.$emit('save', this.model);
    },
    toggleModal() {
      this.setToggle({ type: 'export_file_modal', bool: true });
    },
  },
};
</script>
